import React, { useEffect, useState } from 'react';
import useLocalStorage from 'use-local-storage';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { FaSpinner } from 'react-icons/fa';

import { dominioOperaAspNet, dominioDemandaCirurgica } from '../../config/database';

export default function ImpressaoSolicitacaoAIHIdentificacaoPaciente({
  pedido,
  alterarPassoDadosAIH,
  idLegadoPaciente,
  closeDialog,
}) {
  const [solicitacaoAIH, setSolicitacaoAIH] = useLocalStorage('solicitacaoAIH', undefined);
  const [sexoSelecionado, setSexoSelecionado] = useState('');
  const listaSexo = ['M', 'F'];
  const [carregarSubmit, setCarregarSubmit] = useState(false);

  const preencherDadosPacientes = () => {
    dominioOperaAspNet.get(`/api/buscarDadosPacienteAIH/${idLegadoPaciente}`).then(response => {
      const solicitacao = {
        ...solicitacaoAIH,
        numeroProntuario: response.data.prontuario,
        nome: response.data.nome,
        cns: response.data.cns,
        dataNascimento: response.data.dataNascimento.split('T')[0],
        sexo: response.data.sexo,
        raca: response.data.raca,
        telefoneMae: response.data.telefone
          .replace(' ', '')
          .replace('-', '')
          .replace(' ', ''),
        nomeMae: response.data.nomeMae,
        municipioResidencia: response.data.municipio,
        codigoMunicipioIBGE: response.data.codigoIBGE,
        uf: response.data.uf,
        cep: response.data.cep.replace('.', '').replace('-', ''),
        endereco: response.data.endereco,
      };
      setSolicitacaoAIH(solicitacao);
      setSexoSelecionado(response.data.sexo);
    });
  };

  useEffect(() => {
    preencherDadosPacientes();
  }, []);

  const handleSubmit = e => {
    e.preventDefault();

    setCarregarSubmit(true);

    pedido.dataImpressaoAIH ?
      dominioDemandaCirurgica().then(promise => {
        window.open(`${promise.config.baseURL}/solicitacaoAIH/${pedido.id}`);
        closeDialog();
      }) :
      alterarPassoDadosAIH(1);
  };

  return (
    <Container style={{ height: '100%' }}>
      {pedido.dataImpressaoAIH ?
        <>
          <form onSubmit={handleSubmit}>
            <strong className="confirmacao-de-reimpressao">Este documento já foi impresso. <br />Tem certeza de que deseja reimprimi-lo?</strong>

            <Grid item xs={12} sm={12}>
              <div className="div-botoes">
                <Button type="submit" variant="contained" color="primary">
                  {carregarSubmit ? (
                    <FaSpinner color="#FFF" className="loading" size={14} />
                  ) : (
                    <> Imprimir </>
                  )}
                </Button>
                <Button
                  type="button"
                  variant="contained"
                  color="secondary"
                  onClick={() => closeDialog()}
                >
                  Cancelar
                </Button>
              </div>
            </Grid>
          </form>
        </> :
        <>
          <b>Identificação do paciente</b>
          <br />
          <br />
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={3} sm={3}>
                <TextField
                  autoComplete="off"
                  name="numeroProntuario"
                  variant="outlined"
                  fullWidth
                  id="numeroProntuario"
                  label="Nº do prontuario"
                  InputLabelProps={{ shrink: true }}
                  value={solicitacaoAIH ? solicitacaoAIH.numeroProntuario : undefined}
                  onChange={e => {
                    const solicitacao = { ...solicitacaoAIH, numeroProntuario: e.target.value };
                    setSolicitacaoAIH(solicitacao);
                  }}
                  inputProps={{ maxLength: 9, style: { textTransform: 'uppercase' } }}
                  required
                />
              </Grid>
              <Grid item xs={9} sm={9}>
                <TextField
                  autoComplete="off"
                  name="nome"
                  variant="outlined"
                  fullWidth
                  id="nome"
                  label="Nome do paciente"
                  InputLabelProps={{ shrink: true }}
                  value={solicitacaoAIH ? solicitacaoAIH.nome : undefined}
                  onChange={e => {
                    const solicitacao = { ...solicitacaoAIH, nome: e.target.value };
                    setSolicitacaoAIH(solicitacao);
                  }}
                  inputProps={{ maxLength: 200, style: { textTransform: 'uppercase' } }}
                  required
                />
              </Grid>
              <Grid item xs={3} sm={3}>
                <TextField
                  autoComplete="off"
                  name="cns"
                  variant="outlined"
                  fullWidth
                  id="cns"
                  label="CNS"
                  InputLabelProps={{ shrink: true }}
                  value={solicitacaoAIH ? solicitacaoAIH.cns : undefined}
                  onChange={e => {
                    const solicitacao = { ...solicitacaoAIH, cns: e.target.value };
                    setSolicitacaoAIH(solicitacao);
                  }}
                  inputProps={{ maxLength: 15, style: { textTransform: 'uppercase' } }}
                  required
                />
              </Grid>
              <Grid item xs={3} sm={3}>
                <TextField
                  autoComplete="off"
                  name="dataNascimento"
                  variant="outlined"
                  fullWidth
                  id="dataNascimento"
                  label="Data de nascimento"
                  InputLabelProps={{ shrink: true }}
                  value={solicitacaoAIH ? solicitacaoAIH.dataNascimento : undefined}
                  onChange={e => {
                    const solicitacao = { ...solicitacaoAIH, dataNascimento: e.target.value };
                    setSolicitacaoAIH(solicitacao);
                  }}
                  required
                  type="date"
                />
              </Grid>
              <Grid item xs={2} sm={2}>
                <Autocomplete
                  id="sexo"
                  disableClearable
                  options={listaSexo}
                  fullWidth
                  value={sexoSelecionado}
                  onChange={(e, value) => {
                    const solicitacao = { ...solicitacaoAIH, sexo: value };
                    setSolicitacaoAIH(solicitacao);
                  }}
                  renderInput={params => (
                    <TextField {...params} label="Sexo" variant="outlined" required />
                  )}
                />
              </Grid>
              <Grid item xs={2} sm={2}>
                <TextField
                  autoComplete="off"
                  name="raca"
                  variant="outlined"
                  fullWidth
                  id="raca"
                  label="Raça/cor"
                  InputLabelProps={{ shrink: true }}
                  value={solicitacaoAIH ? solicitacaoAIH.raca : undefined}
                  onChange={e => {
                    const solicitacao = { ...solicitacaoAIH, raca: e.target.value };
                    setSolicitacaoAIH(solicitacao);
                  }}
                  inputProps={{ maxLength: 15, style: { textTransform: 'uppercase' } }}
                  required
                />
              </Grid>
              <Grid item xs={2} sm={2}>
                <TextField
                  autoComplete="off"
                  name="etnia"
                  variant="outlined"
                  fullWidth
                  id="etnia"
                  label="Etnia"
                  InputLabelProps={{ shrink: true }}
                  value={solicitacaoAIH ? solicitacaoAIH.etnia : undefined}
                  onChange={e => {
                    const solicitacao = { ...solicitacaoAIH, etnia: e.target.value };
                    setSolicitacaoAIH(solicitacao);
                  }}
                  inputProps={{ maxLength: 15, style: { textTransform: 'uppercase' } }}
                />
              </Grid>
              <Grid item xs={3} sm={3}>
                <TextField
                  autoComplete="off"
                  name="telefoneMae"
                  variant="outlined"
                  fullWidth
                  id="telefoneMae"
                  label="Telefone da mãe"
                  InputLabelProps={{ shrink: true }}
                  value={solicitacaoAIH ? solicitacaoAIH.telefoneMae : undefined}
                  onChange={e => {
                    const solicitacao = { ...solicitacaoAIH, telefoneMae: e.target.value };
                    setSolicitacaoAIH(solicitacao);
                  }}
                  inputProps={{ maxLength: 11, style: { textTransform: 'uppercase' } }}
                />
              </Grid>
              <Grid item xs={9} sm={9}>
                <TextField
                  autoComplete="off"
                  name="nomeMae"
                  variant="outlined"
                  fullWidth
                  id="nomeMae"
                  label="Nome da mãe"
                  InputLabelProps={{ shrink: true }}
                  value={solicitacaoAIH ? solicitacaoAIH.nomeMae : undefined}
                  onChange={e => {
                    const solicitacao = { ...solicitacaoAIH, nomeMae: e.target.value };
                    setSolicitacaoAIH(solicitacao);
                  }}
                  inputProps={{ maxLength: 200, style: { textTransform: 'uppercase' } }}
                  required
                />
              </Grid>
              <Grid item xs={3} sm={3}>
                <TextField
                  autoComplete="off"
                  name="telefoneResponsavel"
                  variant="outlined"
                  fullWidth
                  id="telefoneResponsavel"
                  label="Telefone do responsável"
                  InputLabelProps={{ shrink: true }}
                  value={solicitacaoAIH ? solicitacaoAIH.telefoneResponsavel : undefined}
                  onChange={e => {
                    const solicitacao = { ...solicitacaoAIH, telefoneResponsavel: e.target.value };
                    setSolicitacaoAIH(solicitacao);
                  }}
                  inputProps={{ maxLength: 11, style: { textTransform: 'uppercase' } }}
                />
              </Grid>
              <Grid item xs={9} sm={9}>
                <TextField
                  autoComplete="off"
                  name="nomeResponsavel"
                  variant="outlined"
                  fullWidth
                  id="nomeResponsavel"
                  label="Nome do reposável"
                  InputLabelProps={{ shrink: true }}
                  value={solicitacaoAIH ? solicitacaoAIH.nomeResponsavel : undefined}
                  onChange={e => {
                    const solicitacao = { ...solicitacaoAIH, nomeResponsavel: e.target.value };
                    setSolicitacaoAIH(solicitacao);
                  }}
                  inputProps={{ maxLength: 200, style: { textTransform: 'uppercase' } }}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  autoComplete="off"
                  name="endereco"
                  variant="outlined"
                  fullWidth
                  id="endereco"
                  label="Endereço"
                  InputLabelProps={{ shrink: true }}
                  value={solicitacaoAIH ? solicitacaoAIH.endereco : undefined}
                  onChange={e => {
                    const solicitacao = { ...solicitacaoAIH, endereco: e.target.value };
                    setSolicitacaoAIH(solicitacao);
                  }}
                  inputProps={{ maxLength: 50, style: { textTransform: 'uppercase' } }}
                  required
                />
              </Grid>
              <Grid item xs={3} sm={3}>
                <TextField
                  autoComplete="off"
                  name="municipioResidencia"
                  variant="outlined"
                  fullWidth
                  id="municipioResidencia"
                  label="Município de residência"
                  InputLabelProps={{ shrink: true }}
                  value={solicitacaoAIH ? solicitacaoAIH.municipioResidencia : undefined}
                  onChange={e => {
                    const solicitacao = { ...solicitacaoAIH, municipioResidencia: e.target.value };
                    setSolicitacaoAIH(solicitacao);
                  }}
                  inputProps={{ maxLength: 50, style: { textTransform: 'uppercase' } }}
                  required
                />
              </Grid>
              <Grid item xs={3} sm={3}>
                <TextField
                  autoComplete="off"
                  name="codigoMunicipioIBGE"
                  variant="outlined"
                  fullWidth
                  id="codigoMunicipioIBGE"
                  label="Cod. IBGE município"
                  InputLabelProps={{ shrink: true }}
                  value={solicitacaoAIH ? solicitacaoAIH.codigoMunicipioIBGE : undefined}
                  onChange={e => {
                    const solicitacao = { ...solicitacaoAIH, codigoMunicipioIBGE: e.target.value };
                    setSolicitacaoAIH(solicitacao);
                  }}
                  inputProps={{ maxLength: 9, style: { textTransform: 'uppercase' } }}
                  required
                />
              </Grid>
              <Grid item xs={3} sm={3}>
                <TextField
                  autoComplete="off"
                  name="uf"
                  variant="outlined"
                  fullWidth
                  id="uf"
                  label="UF"
                  InputLabelProps={{ shrink: true }}
                  value={solicitacaoAIH ? solicitacaoAIH.uf : undefined}
                  onChange={e => {
                    const solicitacao = { ...solicitacaoAIH, uf: e.target.value };
                    setSolicitacaoAIH(solicitacao);
                  }}
                  inputProps={{ maxLength: 2, style: { textTransform: 'uppercase' } }}
                  required
                />
              </Grid>
              <Grid item xs={3} sm={3}>
                <TextField
                  autoComplete="off"
                  name="cep"
                  variant="outlined"
                  fullWidth
                  id="cep"
                  label="CEP"
                  InputLabelProps={{ shrink: true }}
                  value={solicitacaoAIH ? solicitacaoAIH.cep : undefined}
                  onChange={e => {
                    const solicitacao = { ...solicitacaoAIH, cep: e.target.value };
                    setSolicitacaoAIH(solicitacao);
                  }}
                  inputProps={{ maxLength: 9, style: { textTransform: 'uppercase' } }}
                  required
                />
              </Grid>
              <Grid item xs={10} sm={10} />
              <Grid item xs={2} sm={2}>
                <Button type="submit" variant="contained" color="primary" style={{ float: 'right' }}>
                  Próximo
                </Button>
              </Grid>
            </Grid>
          </form>
        </>
      }
    </Container>
  );
}
